export const Logger = (store: any) => (next: any) => (action: any) => {
  let result = next(action)
  console.group(action.type)
  console.info('dispatching', action)
  console.log('next state', store.getState())
  console.groupEnd()
  return result
}